import { Suspense } from 'react';
import PageLoader from './PageLoader';

/**
 * LazyLoadWrapper - Wraps lazy-loaded components with a loading fallback
 * @param {React.ReactNode} children - The lazy-loaded component
 * @param {React.ReactNode} fallback - Optional custom loading component
 */
const LazyLoadWrapper = ({ children, fallback }) => {
  return <Suspense fallback={fallback || <PageLoader />}>{children}</Suspense>;
};

export default LazyLoadWrapper;
